<template>
    <v-container>
      <v-row>
        <v-toolbar>
          <v-toolbar-title ><v-btn router to="/Home">MTS Fintech</v-btn></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text router to="/Topuppage">เติมเงินโทรศัพท์</v-btn>
            <v-btn text router to="/Fail_report">รายงานการเติมเงิน</v-btn>
            <v-btn text @click="setLogout">Logout</v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-row>
    </v-container>
  
</template>

<script>
export default {
    name: 'Navbar',
    methods:{
        setLogout:function(){
        alert("logout!");
        this.$store.commit('setLogin',false);
        this.$store.commit('setUsername','');
        this.$store.commit('setPassword','');
        this.$router.replace({name : "Loginpage"});
        
        }
    }
}
</script>

<style>

</style>